import { ITextJoinBehavior } from "./ITextJoinBehavior";

export interface ITextJoinBehaviorSpecifiable {
  textJoinBehavior: ITextJoinBehavior;
}

export function instanceOfITextJoinBehaviorSpecifiable(instance: any): instance is ITextJoinBehaviorSpecifiable {
  return instance
    && (instance.textJoinBehavior !== undefined);
}
